import { ButtonRoot } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { type RecType } from '@/defs/rec'
import { useCardModalButton } from '@/hooks/useCardModalButton'

import styles from '../CardControls.module.scss'

type Props = {
  rec: RecType
}

export const CardControlsModal = ({ rec }: Props) => {
  const { cardLink, onClick } = useCardModalButton({ rec })

  return (
    <li className={styles.item}>
      <ButtonRoot
        aria-label='More info'
        as='LinkRoute'
        className={styles.button}
        href={cardLink}
        onClick={onClick}
        title='More info'
      >
        <Icon name='ellipsisV' />
      </ButtonRoot>
    </li>
  )
}
